export enum PlanLaterType {
  MANDATORY = "mandatory",
  MANDATORY_CHOICE = "mandatoryChoice",
  SPECIALISATION = "specialisation",
  ELECTIVES_MINOR = "electivesMinor",
  ELECTIVES_COURSES = "electivesCourses",
  OTHER_COURSES = "otherCourses",
  REPLACEMENT_COURSES = "replacementCourses",
}
